module.exports = __webpack_public_path__ + "img/full7-min.123a19e8.png";